import React from 'react';
import {View, StyleSheet} from 'react-native';
import {Button} from 'ui-kits';
import {spacing} from 'theme/Units';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  pageHandler: (pageNumber: number) => void;
};

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  pageHandler,
}) => {
  function pageNumbers() {
    const pageRange = [];
    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pageRange.push(i);
      }
      return pageRange;
    }
    if (currentPage === 1 || currentPage === 2) {
      return [1, 2, 3];
    }
    if (currentPage === totalPages || currentPage === totalPages - 1) {
      return [totalPages - 2, totalPages - 1, totalPages];
    }
    return [currentPage - 1, currentPage, currentPage + 1];
  }

  return (
    <View style={styles.paginationContainer}>
      <Button
        style={styles.actionButton}
        text="Previous"
        onPress={() => pageHandler(Math.max(currentPage - 1, 1))}
        variant="secondary"
        disabled={currentPage === 1}
      />
      {pageNumbers().map(page => (
        <Button
          key={page}
          style={styles.pageButton}
          text={page.toString()}
          onPress={() => pageHandler(page)}
          variant={currentPage === page ? 'primary' : 'secondary'}
        />
      ))}
      <Button
        style={styles.actionButton}
        text="Next"
        onPress={() => pageHandler(Math.min(currentPage + 1, totalPages))}
        variant="secondary"
        disabled={currentPage === totalPages}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  paginationContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    gap: spacing['2'],
    maxHeight: 40,
    marginVertical: spacing['4'],
    zIndex: -1,
  },
  actionButton: {
    maxWidth: 100,
  },
  pageButton: {
    minWidth: 0,
    maxWidth: 40,
  },
});
